document.addEventListener('turbo:load', function () {
  const input = document.getElementsByClassName('iti__tel-input')[0]
  const dropdown = document.getElementById('iti-0__dropdown-content')

  document.getElementsByClassName('iti')[0].addEventListener('click', function() {
    if(dropdown) {
      const offset = 10 + input.getBoundingClientRect().height + dropdown.getBoundingClientRect().height
      dropdown.style.position = 'relative'
      dropdown.style.top = '-' + offset + 'px'
      dropdown.appendChild(dropdown.firstElementChild)
    }
  })
})
